import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import withStyles from "@mui/styles/withStyles";
import actions from "../../../actions";
import styles from "./InsuranceUtility/styles";

import {
  getCreatePlanLoading,
  getCreatePlanSuccess,
  getCreatePlanError,
  getCreateProviderError,
  getCreateProviderLoading,
  getCreateProviderSuccess,
  getInsuranceListProviderId,
  getInsuranceListState,
  getInsurancePlansPage,
  getInsurancePlansRowsPerPage,
  getInsurancePlansSort,
  getInsurancePlansSortDirection,
  getUpdatePlanLoading,
  getUpdatePlanSuccess,
  getUpdatePlanError,
} from "selectors";
import InsuranceTable from "./InsuranceTable";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Slide, Stack } from "@mui/material";
import { InsuranceCompanyConfig } from "../company/InsuranceCompanyConfig";
import { InsuranceCompanyForm } from "../company/InsuranceCompanyForm";
import { InsurancePlanConfig } from "../plan/InsurancePlanConfig";
import { ANTableFilters } from "@answersnow/pkg-theme";
import { PencilSimpleLine } from "@phosphor-icons/react";
import { Theme } from "@mui/material/styles";
import InsurancePlanEdit from "./InsurancePlanEdit";
import InsurancePlanView from "components/AnLibraries/Insurance/InsurancePlanView";
import CompanyEdit from "./CompanyEdit";

interface InsuranceUtilityProps {
  activePanel: string;
  createInsuranceProvider: (data: any) => void;
  createPlanError: boolean;
  createPlanLoading: boolean;
  createPlanSuccess: boolean;
  createProviderError: boolean;
  createProviderLoading: boolean;
  createProviderSuccess: boolean;
  clearInsuranceListFilters: () => void;
  dataPanel: any;
  editMode: boolean;
  filtersMenuItems: any[];
  finishSubmit: (message: string, errorState: boolean) => void;
  getInsurancePlans: () => void;
  getInsuranceProviders: () => void;
  insuranceListProviderId: any;
  insuranceListState: any;
  insurancePlansData: any[];
  isDirty: boolean;
  isFetchingData: boolean;
  isPanelOpen: boolean;
  orderBy: any;
  orderingMenuItems: any[];
  page: number;
  paginationModel: any;
  resetDataPanel: () => void;
  rowCount: number;
  rowsPerPage: number;
  saveButtonTitle: string;
  setCompanyFilter: (...args: any[]) => void;
  setCoverageStateFilter: (...args: any[]) => void;
  setDataPanel: (data: any) => void;
  setEditMode: (value: boolean) => void;
  setIsCancelClicked: (value: boolean) => void;
  setIsDirty: (value: boolean) => void;
  setIsPanelOpen: (value: boolean) => void;
  setOpenWarning: (value: boolean) => void;
  setOrderBy: (...args: any[]) => void;
  setPage: (page: number) => void;
  setPaginationModel: (...args: any[]) => void;
  setPlanFilter: (...args: any[]) => void;
  setRowsPerPage: (rowsPerPage: number) => void;
  setSaveButtonTitle: (title: string) => void;
  setSort: (sort: any) => void;
  setUnsavedChanges: (value: boolean) => void;
  setUploadedDateFilter: (...args: any[]) => void;
  sort: any;
  sortDirection: any;
  theme: Theme;
  titlePanel: string;
  unsavedChanges: boolean;
  updateActivePanel: (panel: string) => void;
  updateDataPanel: (name: string, value: any) => void;
  updateInputsForm: (...args: any[]) => void;
  updateInsuranceProvider: (data: any) => void;
  updatePlanError: boolean;
  updatePlanLoading: boolean;
  updatePlanSuccess: boolean;
  updateTitlePanel: (title: string) => void;
  uploadedDateFilter: any;
}

const mapStateToProps = (state) => ({
  page: getInsurancePlansPage(state),
  rowsPerPage: getInsurancePlansRowsPerPage(state),
  sort: getInsurancePlansSort(state),
  sortDirection: getInsurancePlansSortDirection(state),
  insuranceListState: getInsuranceListState(state),
  insuranceListProviderId: getInsuranceListProviderId(state),
  createPlanLoading: getCreatePlanLoading(state),
  createPlanSuccess: getCreatePlanSuccess(state),
  createPlanError: getCreatePlanError(state),
  createProviderLoading: getCreateProviderLoading(state),
  createProviderSuccess: getCreateProviderSuccess(state),
  createProviderError: getCreateProviderError(state),
  updatePlanLoading: getUpdatePlanLoading(state),
  updatePlanSuccess: getUpdatePlanSuccess(state),
  updatePlanError: getUpdatePlanError(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsuranceProviders: actions.getInsuranceProvidersList,
      createInsuranceProvider: actions.createInsuranceProvider,
      updateInsuranceProvider: actions.updateInsuranceProvider,
      setInsuranceListState: actions.setInsuranceListState,
      setInsuranceListProviderId: actions.setInsuranceListProviderId,
      clearInsuranceListFilters: actions.clearInsuranceListFilters,
      setPage: actions.setInsurancePlansPage,
      setRowsPerPage: actions.setInsurancePlansRowsPerPage,
      setSort: actions.setInsurancePlansSort,
    },
    dispatch
  );

class InsuranceUtility extends Component<InsuranceUtilityProps, Record<string, never>> {
  constructor(props: InsuranceUtilityProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getInsuranceProviders();
  }

  componentDidUpdate(prevProps: InsuranceUtilityProps) {
    if (prevProps.createProviderLoading && !this.props.createProviderLoading) {
      if (this.props.createProviderSuccess) {
        this.resetPage();
        this.props.finishSubmit("Insurance company successfully added to the library", false);
        this.props.getInsurancePlans();
      } else if (this.props.createProviderError) {
        this.props.finishSubmit("Error creating Insurance company", true);
      }
    }
    if (prevProps.createPlanLoading && !this.props.createPlanLoading) {
      if (this.props.createPlanSuccess) {
        this.resetPage();
        this.props.finishSubmit("Insurance plan successfully added to the library", false);
        this.props.getInsurancePlans();
      } else if (this.props.createPlanError) {
        this.props.finishSubmit("Error creating Insurance plan", true);
      }
    }
    if (prevProps.updatePlanLoading && !this.props.updatePlanLoading) {
      if (this.props.updatePlanSuccess) {
        this.resetPage();
        this.props.finishSubmit("Insurance plan successfully updated", false);
        this.props.getInsurancePlans();
      } else if (this.props.updatePlanError) {
        this.props.finishSubmit("Error updating Insurance plan", true);
      }
    }
    if (
      prevProps.sort !== this.props.sort ||
      prevProps.page !== this.props.page ||
      prevProps.sortDirection !== this.props.sortDirection ||
      prevProps.rowsPerPage !== this.props.rowsPerPage ||
      prevProps.insuranceListState !== this.props.insuranceListState ||
      prevProps.insuranceListProviderId !== this.props.insuranceListProviderId
    ) {
      this.props.getInsurancePlans();
    }
  }

  resetPage() {
    this.props.resetDataPanel();
    this.props.setIsDirty(false);
    this.props.setIsPanelOpen(false);
    this.props.setUnsavedChanges(false);
  }

  componentWillUnmount() {
    this.props.clearInsuranceListFilters();
  }

  handleChangeRowsPerPage = (event) => {
    this.props.setRowsPerPage(parseInt(event.target.value));
    this.props.setPage(0);
  };

  onChange = (name, onChangeType, data) => (e) => {
    const { checked, type, value } = e.target;
    if (!onChangeType) {
      let val;
      switch (value) {
        case "Yes":
          val = true;
          break;
        case "No":
          val = false;
          break;
        default:
          val = type === "checkbox" ? checked : value;
      }
      data[name] = val;
      this.props.updateDataPanel(name, val);
    } else if (onChangeType === "radioButtonChange") {
      let parsedValue;
      if (typeof value === "boolean") {
        parsedValue = value;
      } else {
        parsedValue = value === "true";
      }
      data[name] = parsedValue;
      this.props.updateDataPanel(name, parsedValue);
    } else if (onChangeType === "phoneNumberchange") {
      const numberValue = value.replace(/[^0-9]/g, "");
      const phone = numberValue.replace(
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/g,
        "($1)-$2-$3"
      );
      data[name] = phone;
      this.props.updateDataPanel(name, phone);
    } else if (onChangeType === "numberChange") {
      data[name] = value.replace(/[^0-9]/g, "");
      this.props.updateDataPanel(name, value.replace(/[^0-9]/g, ""));
    } else if (onChangeType === "zipCode") {
      data[name] = value;
      this.props.updateDataPanel(name, value);
    }
    this.props.setUnsavedChanges(true);
    this.props.updateInputsForm(
      this.inputForms(data, this.validateRequired(data, onChangeType), this.props.activePanel)
    );
  };

  onToggleCreatePlanDialog = () => {
    if (this.props.isPanelOpen && this.props.unsavedChanges) {
      this.props.setOpenWarning(true);
    } else {
      this.props.setIsPanelOpen(true);
      this.props.setEditMode(true);
      this.props.setIsDirty(true);
      this.props.setUnsavedChanges(false);
      this.props.updateActivePanel("createPlan");
      this.props.updateInputsForm(this.inputForms({}, [], "createPlan"));
    }
  };

  onToggleCreateProviderDialog = () => {
    if (this.props.isPanelOpen && this.props.unsavedChanges) {
      this.props.setOpenWarning(true);
    } else {
      const title = "Add Insurance Company";
      this.props.setIsPanelOpen(true);
      this.props.setIsDirty(true);
      this.props.setUnsavedChanges(false);
      this.props.updateTitlePanel(title);
      this.props.setEditMode(true);
      this.props.setSaveButtonTitle(title);
      this.props.updateActivePanel("createCompany");
      this.props.updateInputsForm(this.inputForms({}, [], "createCompany"));
    }
  };

  inputForms = (data, errors, activePanel) => {
    if (activePanel === "createCompany" || activePanel === "editCompany") {
      return InsuranceCompanyForm(data, errors, this.onChange);
    }
  };

  validateRequired = (data, type) => {
    const errors = {};
    this.props.setIsDirty(false);
    const requiredIds =
      this.props.activePanel === "createCompany" || this.props.activePanel === "editCompany"
        ? InsuranceCompanyConfig.filter((item) => item.required).map((item) => item.id)
        : InsurancePlanConfig.filter((item) => item.required).map((item) => item.id);
    requiredIds.forEach((id) => {
      if (type === "zipCode" && id.includes("zip")) {
        if (data[id]?.length < 5) {
          this.props.setIsDirty(true);
          errors[id + "_format_error"] = true;
        } else if (data[id] === undefined || data[id] === null || data[id].length === 0) {
          this.props.setIsDirty(true);
          errors[id] = true;
        } else {
          this.props.setIsDirty(false);
          errors[id + "_format_error"] = false;
          errors[id] = false;
        }
      } else if (data[id] === undefined || data[id] === null || data[id].length === 0) {
        this.props.setIsDirty(true);
        errors[id] = true;
      } else {
        errors[id] = false;
      }
    });
    return errors;
  };

  render() {
    const {
      insurancePlansData,
      isFetchingData,
      editMode,
      dataPanel,
      resetDataPanel,
      setDataPanel,
      isPanelOpen,
      setIsPanelOpen,
      titlePanel,
      updateTitlePanel,
      updateInputsForm,
      isDirty,
      setIsDirty,
      setSaveButtonTitle,
      saveButtonTitle,
      activePanel,
      updateActivePanel,
      createPlanLoading,
      createProviderLoading,
      setEditMode,
      updatePlanLoading,
      orderBy,
      setOrderBy,
      filtersMenuItems,
      orderingMenuItems,
      paginationModel,
      setPaginationModel,
      setPlanFilter,
      setCompanyFilter,
      setCoverageStateFilter,
      uploadedDateFilter,
      setUploadedDateFilter,
      rowCount,
      theme,
      setOpenWarning,
      setIsCancelClicked,
      unsavedChanges,
    } = this.props;

    const onSave = () => {
      if (!isDirty) {
        if (activePanel === "createCompany") {
          this.props.createInsuranceProvider(dataPanel);
        } else if (activePanel === "editCompany") {
          this.props.updateInsuranceProvider(dataPanel);
        }
      }
    };

    const onCancel = () => {
      if (unsavedChanges) {
        setIsCancelClicked(true);
        setOpenWarning(true);
      } else {
        resetDataPanel();
        setIsDirty(true);
        setIsPanelOpen(false);
        setOpenWarning(false);
      }
    };

    return (
      <Stack
        direction="row"
        sx={{
          height: "calc(100svh - 137px)",
          [theme.breakpoints.down("lg")]: { height: "calc(100svh - 165px)" },
          width: "100%",
        }}
      >
        <Stack flexGrow={1} sx={{ overflowY: "auto" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" p={5}>
            <ANTableFilters
              orderingMenuItems={orderingMenuItems}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              filtersMenuItems={filtersMenuItems}
              filtersButtonProps={{ disabled: insurancePlansData?.length === 0 }}
              searchInput
            />
            <Stack direction="row" gap={3} flexWrap="wrap">
              <Button
                onClick={this.onToggleCreateProviderDialog}
                color="secondary"
                size="small"
                startIcon={<AddIcon />}
              >
                Add Insurance Company
              </Button>
              <Button
                onClick={this.onToggleCreatePlanDialog}
                color="secondary"
                size="small"
                startIcon={<AddIcon />}
              >
                Add Insurance Plan
              </Button>
            </Stack>
          </Stack>
          <Stack>
            <InsuranceTable
              handleChangePage={(_, page) => this.props.setPage(page)}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              handleSortClick={(name) => this.props.setSort({ sort: name })}
              setDataPanel={setDataPanel}
              updateTitlePanel={updateTitlePanel}
              setIsPanelOpen={setIsPanelOpen}
              setEditMode={setEditMode}
              isPanelOpen={isPanelOpen}
              insurancePlansData={insurancePlansData}
              isFetchingData={
                isFetchingData || createProviderLoading || createPlanLoading || updatePlanLoading
              }
              paginationModel={paginationModel}
              setPaginationModel={setPaginationModel}
              uploadedDateFilter={uploadedDateFilter}
              setUploadedDateFilter={setUploadedDateFilter}
              rowCount={rowCount}
              setPlanFilter={setPlanFilter}
              setCompanyFilter={setCompanyFilter}
              setCoverageStateFilter={setCoverageStateFilter}
              unsavedChanges={unsavedChanges}
              setOpenWarning={setOpenWarning}
              {...this.props}
              {...this.state}
            />
          </Stack>
        </Stack>

        <Slide direction="left" in={isPanelOpen} mountOnEnter unmountOnExit>
          <Stack
            sx={{ borderLeft: `1px solid ${theme.palette.divider}`, overflowY: "auto" }}
            width="400px"
            minWidth="400px"
          >
            {editMode ? (
              <>
                {(activePanel === "createPlan" || activePanel === "editPlan") && (
                  <InsurancePlanEdit
                    onChange={this.onChange}
                    updateDataPanel={this.props.updateDataPanel}
                    dataPanel={dataPanel}
                    onCancel={onCancel}
                    isLoading={createPlanLoading || updatePlanLoading}
                    disableSaveButton={isDirty}
                    titlePanel={titlePanel}
                    onRulesChanged={() => this.props.getInsurancePlans()}
                  />
                )}
                {(activePanel === "createCompany" || activePanel === "editCompany") && (
                  <CompanyEdit
                    onChange={this.onChange}
                    data={dataPanel}
                    onSave={onSave}
                    onCancel={onCancel}
                    isLoading={createPlanLoading || updatePlanLoading}
                    disableSaveButton={isDirty}
                    saveTitle={saveButtonTitle}
                    titlePanel={titlePanel}
                  />
                )}
              </>
            ) : (
              <Stack>
                <InsurancePlanView
                  title={titlePanel}
                  onClose={() => {
                    setIsPanelOpen(false);
                    resetDataPanel();
                  }}
                  data={dataPanel}
                  topEditActions={[
                    {
                      icon: <PencilSimpleLine weight="duotone" />,
                      text: "Edit Plan",
                      action: () => {
                        updateTitlePanel(dataPanel?.name ?? "Edit insurance plan");
                        setEditMode(true);
                        setSaveButtonTitle("Save Changes");
                        updateActivePanel("editPlan");
                        updateInputsForm(this.inputForms(dataPanel, [], "editPlan"));
                      },
                    },
                    {
                      icon: <PencilSimpleLine weight="duotone" />,
                      text: "Edit Company",
                      action: () => {
                        updateTitlePanel(dataPanel?.insurance_name ?? "Edit insurance company");
                        setEditMode(true);
                        setSaveButtonTitle("Save Changes");
                        updateActivePanel("editCompany");
                        const companyData = {
                          name: dataPanel.insurance_name,
                          id: dataPanel.insurance_id,
                          contract_type: dataPanel.contract_type,
                        };
                        setDataPanel(companyData);
                        updateInputsForm(this.inputForms(companyData, [], "editCompany"));
                      },
                    },
                  ]}
                />
              </Stack>
            )}
          </Stack>
        </Slide>
      </Stack>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(InsuranceUtility));
